<template>
    <div class="repair">
        <iframe src="" frameborder="0" ref="iframe" class="print-iframe"></iframe>
        <div class="df both-side">
            <a-space>
                <range-time :placeholder="['生产开始时间', '生产结束时间']" :source="requestPayload"
                    :target="['produceStartTime', 'produceEndTime']" @onChange="handleSearch" style="width: 220px;" />

                <range-time :placeholder="['反馈日期', '反馈日期']" :source="requestPayload" :target="['startDate', 'endDate']"
                    @onChange="setDate" style="width: 220px;" />

                <a-select v-model:value="requestPayload.serialType" :options="machineOptions" @change="() => {
                    requestPayload.model = null; handleSearch();
                }" style="width: 110px;" placeholder="设备类型" :showSearch="true" allowClear>
                </a-select>

                <a-select v-model:value="requestPayload.model" :options="serialModelOptions[requestPayload.serialType]"
                    style="width: 120px;" placeholder="设备型号" :showSearch="true" @change="handleSearch" allowClear>

                </a-select>

                <a-select v-model:value="requestPayload.status" placeholder="报修状态" @change="handleSearch"
                    :options="statusOptions" allowClear>
                </a-select>

                <a-select v-model:value="requestPayload.problemType" placeholder="问题类型" @change="handleSearch"
                    :options="questionTypeOptions" allowClear></a-select>

                <a-input v-model:value="requestPayload.serial" placeholder="机身号" allowClear
                    @change="handleSearch"></a-input>
            </a-space>

            <a-space>
                <a-button :disabled="!hasSelected" size="small" @click="exportAfterSaleRecord">导出数据</a-button>
                <!-- <a-button :disabled="!hasSelected" size="small" @click="handlePrint">打印</a-button> -->
                <a-button type="primary" size="small" @click="handleUpdateRepairDevice('insert', {
                    title: '新增报修', data: null, role: 'afterSales'
                })">新增报修</a-button>
            </a-space>
        </div>

        <div style="height: calc(100vh - 310px);">
            <a-table :data-source="table.data" bordered :pagination="false" :rowClassName="setRecordStatus"
                :loading="loading" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                :scroll="{ x: 'calc(100vw - 300px)', y: 'calc(100vh - 410px)' }" :columns="columns" rowKey="id"
                class="space">

                <template #problemPhenomenon="{ record }">

                    <div v-for="(item, index) in record.problemPhenomenon.split('#')" :key="index">
                        {{ index + 1 }}：{{ item }}
                    </div>
                </template>

                <template #serialType="{ record }">
                    {{ setSerialType(record.serialType) }}
                </template>

                <template #picture="{ record }">
                    <cus-image :value="record.picture"></cus-image>
                </template>

                <template #video="{ record }">
                    <!-- <cus-video :value="record.video"></cus-video> -->
                    <preview-video :value="record.video" v-if="record.video && record.video !== '[]'"></preview-video>
                </template>

                <template #status="{ record }">
                    <a-tag :color="setRecordStatus(record)">
                        {{ record.status }}
                    </a-tag>
                </template>

                <template #model="{ record }">
                    {{ record.model.replace(/columba|Swan|SCX/, '') }}
                </template>

                <template #recipient="{ record }">
                    <div>
                        {{ getTextNickName(record.recipient) }}
                    </div>
                </template>

                <template #analysisDept="{ record }">
                    <!-- {{ record.analysisDept?.split(',')[2] }}{{ record.analysisDept?.split(',')[0] }} -->
                    {{ getStructureNameAndNickName(record.analysisDept) }}
                </template>

                <template #executionDept="{ record }">
                    {{ getStructureNameAndNickName(record.executionDept) }}
                    <!-- {{ record.executionDept?.split(',')[2] }}{{ record.executionDept?.split(',')[0] }} -->
                </template>

                <template #action="{ record }">
                    <a-dropdown>
                        <template #overlay>
                            <a-menu @click="handleAction($event, record)">
                                <a-menu-item key="edit"
                                    :disabled="record.status === '已完成' ? true : !updateAuthority(record)">编辑</a-menu-item>
                                <a-menu-item key="analysis"
                                    :disabled="record.status === '已完成' ? true : !analysisAuthority">问题分析</a-menu-item>
                                <a-menu-item key="confirm"
                                    :disabled="record.status === '已完成' ? true : !qualityAuthority">质量确认</a-menu-item>
                                <a-menu-item key="delete"
                                    :disabled="record.status === '已完成' ? true : !qualityAuthority">删除</a-menu-item>
                            </a-menu>
                        </template>
                        <a-button type="primary" size="small">
                            操作
                            <DownOutlined />
                        </a-button>
                    </a-dropdown>
                </template>
            </a-table>
        </div>

        <div class="df both-side" style="margin-top: 5px;">
            <div></div>
            <a-pagination size="small" :total="table.total" :show-total="total => `共 ${total} 条`" class="space"
                show-size-changer @showSizeChange="hanldeUpdatePageNum" v-model:pageSize="table.lineNum"
                :page-size-options="['10', '20', '300', '900', '1500']" v-model:current="table.pageNum"
                @change="hanldeUpdatePageNum" />
        </div>

        <repair-form ref="repairFormRef" @handleUpdateTable="getData"></repair-form>
    </div>

</template>

<script>
import { defineComponent, ref, toRefs, computed, reactive } from "vue";
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { Modal } from 'ant-design-vue';
import { Toast, timeStampToTime } from "@/utils";
import { useTable } from "@/views/notice/serve/table";
import { getAfterSaleRepairList, deleteAfterSaleRepair, updateAfterSaleRepair, exportAfterSaleRepair } from '@/request/view/afterSale';
import { DownOutlined } from '@ant-design/icons-vue';
import { statusOptions, questionTypeOptions } from './data';
import { machineOptions, serialModelOptions } from '@/components/cascader/option';
import { getTextNickName, getStructureNameAndNickName } from '@/components/chooseStaff/serve';
import rangeTime from '@/components/daypicker/index.vue';
import seriesTypeCascader from '@/components/cascader/index.vue';
import repairForm from '@/views/afterSaleRepair/pc/reform.vue';
import cusImage from '@/components/img/index.vue';
import cusVideo from '@/components/video/index.vue';
import previewVideo from '@/components/video/preview.vue';

export default defineComponent({
    components: {
        rangeTime,
        seriesTypeCascader,
        repairForm,
        cusImage,
        cusVideo,
        previewVideo,
        DownOutlined,
    },
    setup(props, context) {
        const {
            requestConfig,
            table,
            requestPayload,
            initPayload,
            getListData,
            searchData,
            deleteRecords,
        } = useTable();

        const loading = ref(false);

        const route = useRoute();
        const iframe = ref();
        const user = useStore().state.user.user;

        const updateAuthority = (record) => user.id === record.createUserId;

        const developanAlysisAuthority = user.firstLevelDepartment === '工程部' || user.firstLevelDepartment === '研发中心';

        const productAlysisAuthority = user.firstLevelDepartment === '试产中心';

        const analysisAuthority = process.env.NODE_ENV === 'production' ? productAlysisAuthority : developanAlysisAuthority;

        const qualityAuthority = user.firstLevelDepartment === '质量部';

        const repairFormRef = ref();

        requestConfig.pull_fn = getAfterSaleRepairList;
        requestConfig.delete_fn = deleteAfterSaleRepair;

        const state = reactive({
            selectedRowKeys: [],
            loading: false,
        });
        const hasSelected = computed(() => state.selectedRowKeys.length > 0);

        const onSelectChange = selectedRowKeys => {
            state.selectedRowKeys = selectedRowKeys;
        };

        initPayload({
            endDate: null,
            lineNum: null,
            pageNum: null,
            problemType: null,
            produceEndTime: null,
            produceStartTime: null,
            serial: route.query.serial,
            model: null,
            serialType: null,
            startDate: null,
            status: null
        });

        const columns = [
            { title: "序号", dataIndex: "serialNumber", align: "center", width: "60px", fixed: "left" },
            { title: "年度", dataIndex: "year", align: "center", width: "60px", fixed: "left" },
            { title: "反馈日期", dataIndex: "feedbackDate", align: "center", width: "170px", fixed: "left" },
            { title: "生产日期", dataIndex: "produceDate", align: "center", width: "100px", fixed: "left" },
            { title: "机身号", dataIndex: "serial", align: "center", width: "136px", fixed: "left" },
            { title: "设备类型", dataIndex: "serialType", align: "center", width: "100px", slots: { customRender: "serialType" } },
            { title: "设备型号", dataIndex: "model", align: "center", width: "100px", slots: { customRender: "model" } },
            { title: "问题现象", dataIndex: "problemPhenomenon", align: "center", width: "300px", slots: { customRender: "problemPhenomenon" } },
            { title: "图片", dataIndex: "picture", align: "center", width: "150px", slots: { customRender: 'picture' } },
            { title: "视频", dataIndex: "video", align: "center", width: "150px", slots: { customRender: 'video' } },
            { title: "情况确认和分析", dataIndex: "confirmationAndAnalysis", align: "center", width: "175px" },
            { title: "问题类型", dataIndex: "problemType", align: "center", width: "100px" },
            { title: "接收人", align: "center", width: "100px", slots: { customRender: 'recipient' } },
            { title: "根本原因", dataIndex: "rootCauseAnalysis", align: "center", width: "150px" },
            { title: "临时措施", dataIndex: "temporaryMeasures", align: "center", width: "180px" },
            { title: "闭环措施", dataIndex: "closedLoopMeasures", align: "center", width: "180px" },
            { title: "确认执行", dataIndex: "implementationMeasures", align: "center", width: "180px" },
            {
                title: '执行部门',
                children: [
                    { title: "反馈部门", dataIndex: "feedbackDept", align: "center", width: "160px" },
                    { title: "分析部门", dataIndex: "analysisDept", align: "center", width: "160px", slots: { customRender: 'analysisDept' } },
                    { title: "执行部门", dataIndex: "executionDept", align: "center", width: "160px", slots: { customRender: 'executionDept' } },
                    { title: "监督部门", dataIndex: "supervisionDept", align: "center", width: "160px" },
                ]
            },
            { title: "状态", dataIndex: "status", align: "center", width: "100px", slots: { customRender: 'status' } },
            { title: "备注", dataIndex: "notes", align: "center", width: "160px" },
            { title: "操作", slots: { customRender: 'action' }, align: "center", width: "120px", fixed: "right" }
        ];

        const getData = () => {
            loading.value = true;
            getListData().then(() => {
                table.data.forEach((item, index) => {
                    item.serialNumber = index + 1 + ((table.pageNum - 1) * 10);
                });
                loading.value = false;
            });
        }

        const hanldeUpdatePageNum = (page, size) => {
            table.pageNum = page;
            table.lineNum = size;
            state.selectedRowKeys.length = 0;
            getData()
        };

        const handleDelete = (record) => {
            deleteRecords([record.id], { title: "确认删除？" }).then(() => {
                getData();
            });
        }

        const handleSearch = () => {
            table.pageNum = 1;
            getData();
        };

        const handleUpdateRepairDevice = (type, option) => {
            repairFormRef.value.showModal(type, option);
        };

        const handleAction = (e, record) => {
            const { key } = e;
            switch (key) {
                case 'edit':
                    handleUpdateRepairDevice('edit', {
                        title: '修改信息', data: record, role: 'afterSales'
                    });
                    break;
                case 'delete':
                    handleDelete(record);
                    break;
                case 'analysis':
                    handleUpdateRepairDevice('analysis', {
                        title: '分析原因', data: record, role: user.firstLevelDepartment === '研发中心' ? 'RND' : 'analysis'
                    })
                    break;
                case 'confirm':
                    checkConfirm(record);
                    break;
                default:
                    break;
            }
        };

        const setRecordStatus = (record, index) => {
            let rowClassName = '';
            const { status } = record;
            switch (status) {
                case '设备返厂':
                    rowClassName = '';
                    break;
                case '问题分析':
                    rowClassName = 'warning';
                    break;
                case '现场维修':
                    rowClassName = '';
                    break;
                case '无法处理':
                    rowClassName = 'fail';
                    break;
                case '已完成':
                    rowClassName = 'success';
                    break;
                default:
                    break;
            }
            return rowClassName;
        };

        const checkConfirm = (record) => {
            Modal.warning({
                title: () => '确认该条报修记录处理完成？',
                okText: "确认",
                closable: true,
                maskClosable: true,
                onOk: () => {
                    updateAfterSaleRepair({
                        id: record.id,
                        status: '已完成',
                        supervisionDept: `${user.firstLevelDepartment}${user.nickName}`
                    }).then((res) => {
                        const type = res.code === 200 ? 'success' : 'warning';
                        Toast(type, res.message, 3);
                        getData()
                    });
                }
            });
        };

        const init = () => {
            getData();
            route.query.serial = null;
        };

        const setPrintData = () => {
            const selectList = table.data.filter((f) => state.selectedRowKeys.findIndex((v) => v === f.id) !== -1);
            localStorage.setItem('qc_afterRepair_print', JSON.stringify(selectList));
        };

        const handlePrint = () => {
            setPrintData();
            iframe.value.style.display = "block";
            const serverUrl = `${window.location.origin}/QC/index.html#/printRepair`;
            const localUrl = `${window.location.origin}/#/printRepair`;
            const url = process.env.NODE_ENV === "production" ? serverUrl : localUrl;
            iframe.value.src = url;
        };

        window.addEventListener("message", (e) => {
            if (e.type === "message" && e.data === "closeIframe") {
                iframe.value.src = "";
                iframe.value.style.display = "none";
            }
        });

        init();

        const exportAfterSaleRecord = () => {
            let params = '';

            state.selectedRowKeys.forEach((item) => {
                params += `ids=${item}&`
            });

            exportAfterSaleRepair(params).then((res) => {
                const link = document.createElement("a");
                const blob = new Blob([res], { type: "application/vnd.ms-excel" });
                link.style.display = "none";
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", `日常报修.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                Toast("success", "下载成功", 3);
            });
        };

        const setSerialType = (serialType) => {
            const item = machineOptions.find((f) => f.value === serialType);

            if (item) return item.label;

            return serialType
        };

        const setDate = (stringTime) => {
            const [startDate, endDate] = stringTime;
            requestPayload.endDate = endDate;
            requestPayload.startDate = startDate;
            if (endDate !== '') {
                requestPayload.endDate = `${endDate} 23:59:59`
            }
            handleSearch()
        };

        return {
            iframe,
            loading,
            serialModelOptions,
            handlePrint,
            ...toRefs(state),
            hasSelected,
            exportAfterSaleRecord,
            onSelectChange,
            table,
            columns,
            getData,
            setDate,
            setSerialType,
            machineOptions,
            getStructureNameAndNickName,
            statusOptions,
            questionTypeOptions,
            handleAction,
            setRecordStatus,
            repairFormRef,
            requestPayload,
            handleDelete,
            handleSearch,
            hanldeUpdatePageNum,
            handleUpdateRepairDevice,
            qualityAuthority,
            analysisAuthority,
            updateAuthority,
            getTextNickName,
        };
    },
});
</script>

<style lang="less" scoped>
.print-iframe {
    position: fixed;
    width: 1200px;
    height: 80%;
    z-index: 999;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid #000;
    box-shadow: 0 0 10px 0 #ccc;
    display: none;
}

.repair {
    :deep(.warning) td {
        background-color: #ffff9b !important;
    }

    :deep(.fail) td {
        background-color: #fff1f0 !important;
    }

    :deep(.success) td {
        background-color: #c7ffdb !important;
    }

    .space {
        margin-top: 20px;
    }

    :deep(.ant-table-thead > tr > th) {
        padding: 6px 8px;
    }

    :deep(.ant-table-tbody > tr > td) {
        padding: 8px;
    }
}
</style>
